"use strict";
import a from "./index.es168.js";
const e = typeof URLSearchParams < "u" ? URLSearchParams : a;
export {
  e as default
};
//# sourceMappingURL=index.es223.js.map
